import { useState, useEffect } from 'react';
import { RefreshCw } from 'lucide-react';

export const SWUpdateBanner = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const [reg, setReg] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      setReg(e.detail);
      setShowUpdate(true);
    };
    window.addEventListener('sw-update-available', handler);
    return () => window.removeEventListener('sw-update-available', handler);
  }, []);

  const handleUpdate = () => {
    if (reg?.waiting) {
      reg.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    window.location.reload();
  };

  if (!showUpdate) return null;

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 bg-emerald-800 text-white rounded-xl shadow-lg px-5 py-3 flex items-center gap-3"
         data-testid="sw-update-banner"
    >
      <RefreshCw className="w-4 h-4 text-amber-400 animate-spin" />
      <span className="text-sm">Nueva versión disponible</span>
      <button onClick={handleUpdate} className="bg-amber-500 hover:bg-amber-400 text-emerald-950 text-xs font-semibold px-3 py-1.5 rounded-lg">
        Actualizar
      </button>
    </div>
  );
};
